import { Organisation } from '@/features'
import { APIClient } from '@/services'

export function useIsMyOrg(organisationId: Organisation.T.Organisation['id']) {
  const { data: profile } = APIClient.Session.useProfile()
  return profile?.organization?.id === organisationId
}
